'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isWeekend;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isWeekend.js